// extracted by mini-css-extract-plugin
export var warningModalMessageWrapper = "warningModal-module--warningModalMessageWrapper--f3108";
export var warningModalMessageWrapperNoFixedSize = "warningModal-module--warningModalMessageWrapperNoFixedSize--e9c47";